import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import Button from '@components/Button';

import CookieManager from './CookieManager';
import { useCookieContext } from './context';

import style from './CookiesNotification.scss';

const cn = bemCssModules(style, 'CookiesNotification');
const ti = getTestId('CookiesNotification');

export const CookiesNotification: CustomFC = props => {
  const { className } = props;
  const { accept, acceptAllCookies, acceptRequiredCookies } = useCookieContext();

  const { t } = useTranslation();

  const [isManage, setIsManage] = useState(false);

  const handleManage = () => {
    setIsManage(prev => !prev);
  };

  if (!!accept.length) return null;
  return (
    <div className={cn(null, [className])}>
      {isManage ? (
        <CookieManager handleClose={handleManage} />
      ) : (
        <>
          <div className={cn('content')}>
            <div className={cn('title')}>{t('cookies.main.header')}</div>
            <div className={cn('description')}>
              {t('cookies.main.description')}{' '}
              <button className={cn('manage', ['link'])} onClick={handleManage}>
                {t('cookies.main.learn')}
              </button>
            </div>
          </div>
          <div className={cn('buttons')}>
            <Button className={cn('button')} onClick={acceptAllCookies}>
              {t('cookies.main.accept_all')}
            </Button>
            <Button className={cn('button')} outline onClick={acceptRequiredCookies}>
              {t('cookies.main.reject')}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default CookiesNotification;
